module.exports = __webpack_public_path__ + "media/images/brussels_page/logo4-b760a834001780fc3745ebbbf0489962.svg";